<!--
 * @Desc: 公告通知
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-13 08:20:27
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-notice">
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/notice-title.png"
                    />
                </div>
                <div class="title-more">
                    了解更多
                    <img class="thu" src="../../../public/statics/images/arr.png">
                </div>
            </div>
            <div class="notice-hold">
                <div class="notice-left">
                    <div class="left-item" v-for="i in 3">
                        <div class="thu-hold">
                            <img class="thu" src="../../../public/statics/images/Index/news1.jpg">
                        </div>
                        <div class="info">
                            <div class="title ellipsis1">地理中心教研室公开课暨优质课比赛…</div>
                            <div class="desc ellipsis2">中国共产党第二十次全国代表大会，是在全党全国各族人民迈上全面建设社会主义现代化国家新征程…</div>
                            <div class="time">2023年2月20日</div>
                        </div>
                    </div>
                </div>
                <div class="notice-right">
                    <div class="right-item" v-for="i in 9">
                        <div class="title ellipsis1">河北廊坊恒源中学知名校友风采征集公告…</div>
                        <div class="time"><span>26</span> 2023-3</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            };
        },
        computed: {
        },
        // watch:{
        //     $route(val){
        //         this.pageChange(val.name);
        //     }
        // },
        created: function () {
        },
        methods: {
        },
    }
</script>

<style scoped>
.page-notice{
    width:100%;
    height: 790px;
    background: url(../../../public/statics/images/Index/notice-bg.jpg) no-repeat top center #f0f2f5;
}
.page-notice .container{
    padding-top: 102px;
}
.page-notice .title-hold .title::after{
    width: 150px;
    height: 28px;
    background: url(../../../public/statics/images/Index/notice-desc.png);
}
.page-notice .notice-hold{
    position: relative;
    margin-top: 30px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
}
.page-notice .notice-hold::after{
    content: '';
    position: absolute;
    z-index: 0;
    left: 0;
    top: 0;
    width: 1200px;
    height: 165px;
    background: #FFFFFF;
}
.page-notice .notice-hold .notice-left{
    position: relative;
    z-index: 2;
    flex: 1;
}
.page-notice .notice-hold .notice-left .left-item{
    display: flex;
    cursor: pointer;
    margin-top: 24px;
}
.page-notice .notice-hold .notice-left .left-item:first-child{
    margin-top: 0;
}
.page-notice .notice-hold .notice-left .left-item .thu-hold{
    width: 220px;
    height: 150px;
    margin-right: 22px;
}
.page-notice .notice-hold .notice-left .left-item .thu-hold .thu{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.page-notice .notice-hold .notice-left .left-item .info{
    
}
.page-notice .notice-hold .notice-left .left-item .info .title{
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
    text-align: left;
    vertical-align: middle;
    padding-top: 20px;
    padding-bottom: 10px;
    position: relative;
}
.page-notice .notice-hold .notice-left .left-item .info .title::after {
    position: absolute;
    content: "";
    transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    transform: scaleX(0);
    transform-origin: right;
    background-color: #E22F24;
    right: 0px;
    bottom: 0px;
    left: 0px;
    height: 2px;
}
/* 滑入 */
.page-notice .notice-hold .notice-left .left-item:hover  .title{
    color: #E22F24;
}
.page-notice .notice-hold .notice-left .left-item:hover  .title::after {
    transform: scaleX(1);
    transform-origin: left;
}
.page-notice .notice-hold .notice-left .left-item .info .desc{
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(0, 0, 0, 1);
    text-align: left;
    vertical-align: top;
    padding-right: 10px;
    height: 44px;
    margin-top: 6px;
    margin-bottom: 8px;
}
.page-notice .notice-hold .notice-left .left-item .info .time{
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(173, 180, 199, 1);
    text-align: left;
    vertical-align: top;
}
.page-notice .notice-hold .notice-right{
    position: relative;
    z-index: 2;
    width: 482px;
    height: 498px;
    background: #FFFCF8;
    margin-left: 48px;
    padding: 27px 40px 34px 34px;
}
.page-notice .notice-hold .notice-right .right-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    cursor: pointer;
}
.page-notice .notice-hold .notice-right .right-item:last-child{
    margin: 0;
}

.page-notice .notice-hold .notice-right .right-item:last-child::after{
    display: none;
}
.page-notice .notice-hold .notice-right .right-item::after{
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 100%;
    height: 1px;
    border: 1px dashed #F4D0AD;
}
.page-notice .notice-hold .notice-right .right-item .title{
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
    text-align: left;
    vertical-align: middle;
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.page-notice .notice-hold .notice-right .right-item .time{
    margin-left: 40px;
    font-size: 16px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: #E22F24;
}
.page-notice .notice-hold .notice-right .right-item .time span{
    font-size: 26px;
}
.page-notice .notice-hold .notice-right .right-item:hover .title{
    color: #E22F24;
}
</style>
